const defaultNavigationState = {
    jest: {
        chapter: null,
        activeIndex: 0,
    },
    selenium: {
        chapter: null,
        activeIndex: 0,
    },
    enzyme: {
        chapter: null,
        activeIndex: 0,
    },
    howTo: {
        chapter: null,
        activeIndex: 0,
    },
    concepts: {
        chapter: null,
        activeIndex: 0,
    },
    mechanics: {
        chapter: null,
        activeIndex: 0,
    },
    javascriptBasics: {
        chapter: 'introduction',
        activeIndex: 0,
    },
};

export default defaultNavigationState